$(document).ready(function(){
    $('body').on('click','.has-children',function(e){
      e.preventDefault();
      $(this).toggleClass('active');
      let ele = $(this).siblings('ul');
      $('.teir2').html(`<ul>${ ele.html() }</ul>`);
      $('.teir2').slideToggle(200);
    });
    $('body').on('focusin','.search-form input',function(){
        $('.main-search__results').show();
        $(this).parents('.main-search__container ').addClass('focus');
    }).on('focusout','.search-form input',function(){
        let strLen = $('.main-search__results__products').length;
        let currentDiv = $(this);
          if( strLen > 0 ){
            setTimeout(function(){
              $('.main-search__results').hide();
              $(currentDiv).parents('.main-search__container ').removeClass('focus');
            },1000);
          }else{
            $(this).parents('.main-search__container ').removeClass('focus');
          }
    })
    $('body').on('click','.customFilterBtn',function(){
      $(this).toggleClass('active');
      $('.multi-tag-row').slideToggle();
    })  
});
function onlyNumberKey(evt) {
  // Only ASCII character in that range allowed
  var ASCIICode = (evt.which) ? evt.which : evt.keyCode
  if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
    return false;
  return true;
}